"use client";
import Box from "@mui/material/Box";

interface PlayingBarsProps {
  isPlaying: boolean;
  size?: "small" | "medium";
}

export default function PlayingBars({
  isPlaying,
  size = "medium",
}: PlayingBarsProps) {
  const barWidth = size === "small" ? 2 : 3;
  const barHeights = size === "small" ? [6, 10, 7] : [8, 14, 10];
  const gap = size === "small" ? "2px" : "3px";

  const bars = [
    { height: barHeights[0], delay: "0s" },
    { height: barHeights[1], delay: "0.2s" },
    { height: barHeights[2], delay: "0.4s" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        gap,
        "@keyframes barBounce": {
          "0%, 100%": { transform: "scaleY(0.4)" },
          "50%": { transform: "scaleY(1)" },
        },
      }}
    >
      {bars.map((bar, i) => (
        <Box
          key={i}
          sx={{
            width: barWidth,
            height: bar.height,
            bgcolor: "common.white",
            borderRadius: "1px",
            transformOrigin: "bottom",
            animation: isPlaying
              ? `barBounce 0.8s ease-in-out ${bar.delay} infinite`
              : "none",
            transform: isPlaying ? undefined : "scaleY(0.2)",
          }}
        />
      ))}
    </Box>
  );
}
